import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiInvalidToken, SessionExpireDialogClosed } from '@biz-action/system-actions/auth-token.actions';
import { SessionExpireDialogComponent } from '@biz-ui/containers/session-expire-dialog/session-expire-dialog.component';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, map, switchMap, tap } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class InvalidTokenEffects {
	constructor(private actions$: Actions, private dialog: MatDialog) {}

	displaySessionExpired$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ApiInvalidToken),
			switchMap(() => this._openSessionExpireDialog()),
			map((a) => SessionExpireDialogClosed()),
		),
	);

	private _openSessionExpireDialog() {
		return from(
			import('@biz-ui/containers/session-expire-dialog/session-expire-dialog.module').then(
				(m) => m.SessionExpireDialogModule,
			),
		).pipe(
			map(() =>
				this.dialog.open(SessionExpireDialogComponent, {
					width: '40%',
				}),
			),
			// switchMap((res) => res.result),
		);
	}
}
